export default __webpack_public_path__ + "static/media/hero-cat.c5e665e1.png";